import { render } from "./SecretRoom.vue?vue&type=template&id=0430998e"
import script from "./SecretRoom.vue?vue&type=script&lang=js"
export * from "./SecretRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__